module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/HotDay/Kanagawa_HotDay_MRI_RCP85_End.png";